import { render, staticRenderFns } from "./managed-storefront-widget.vue?vue&type=template&id=2204b78a&"
import script from "./managed-storefront-widget.vue?vue&type=script&lang=js&"
export * from "./managed-storefront-widget.vue?vue&type=script&lang=js&"
import style0 from "./managed-storefront-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports